import {BASE_API} from "../index";

export const CiApi = {
  getAll: async (user_uuid, pagina, ordem, filtro, dataForm) => {
    let response = await fetch(`${BASE_API}/ci`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina,
          ordem,
          filtro,
          dataForm
        }
      )
    })
    return await response.json();
  },

  getAllSearch: async (user_uuid, pagina, search) => {
    let response = await fetch(`${BASE_API}/ci?search=${search}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina
        }
      )
    })
    return await response.json();
  },

  getItem: async (user_uuid, ci_uuid) => {
    let response = await fetch(`${BASE_API}/ci/get`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          ci_uuid
        }
      )
    })
    return await response.json();
  },

  create: async (user_uuid, titulo, setor, funcionario, assunto, texto) => {
    let response = await fetch(`${BASE_API}/ci/create`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          titulo,
          setor,
          funcionario,
          assunto,
          texto
        }
      )
    })
    return await response.json();
  },

  delete: async (user_uuid, ci_uuid) => {
    let response = await fetch(`${BASE_API}/ci/delete`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          ci_uuid
        }
      )
    })
    return await response.json();
  },

  autorizar: async (user_uuid, ci_uuid) => {
    let response = await fetch(`${BASE_API}/ci/autorizar`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          ci_uuid
        }
      )
    })
    return await response.json();
  },

  toggleVisto: async (user_uuid, ci_uuid) => {
    let response = await fetch(`${BASE_API}/ci/togglevisto`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          ci_uuid
        }
      )
    })
    return await response.json();
  },
}